let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cnSp9")).then(() => parcelRequire('gEw1T'));